import PersonNameRequirementOption from "../enum/PersonNameRequirementOption";

const getValuesByPersonNameRequiredOption = (
  option: PersonNameRequirementOption
): [boolean, boolean] => {
  if (option === PersonNameRequirementOption.ALL_REQUIRED) {
    return [true, true];
  }
  if (option === PersonNameRequirementOption.FIRST_NAME_REQUIRED) {
    return [true, false];
  }
  if (option === PersonNameRequirementOption.LAST_NAME_REQUIRED) {
    return [false, true];
  }
  return [false, false];
};

export default getValuesByPersonNameRequiredOption;
